/** @module Specification/PartMaterialColor/PMCSampleRenderer */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,Ref,xml,Query) {
	return declare(Ref, {
		/**
		 * @override
		 * The custom store key is the PMCQuote and PMCColor, PMCSamples will filter based on these
		 */
		getCustomStoreKey: function(ctx, h, bAll) {
			var pmcNode = ctx.getNode();
			var quoteURL = pmcNode.PMCQuote;
			var colorURL = pmcNode.PMCColor;
			if (xml.isValidURL(quoteURL)){
				return quoteURL + "^" + colorURL;
			} else {
				return null;
			}
		},

		/**
		 * @override
		 * Displays samples that has the same supplier as the quote, and contains the color
		 */
		_getStoreAction: function(ctx, h, bAll) {
			var partMaterial = ctx.getNodeParent();
			var partMaterialColor = ctx.getNode();

			var quoteSource = ctx.cache.getNode(partMaterialColor.PMCQuote).__Parent__;
			var color  = partMaterialColor.PMCColor;

			return lang.mixin(new Action(), {
				m_fixedQuery: new Query()
					.RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, quoteSource)
					.RefAttr("ProductColor", xml.OP_EQUALS, color),
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "ProductSamples",
					m_url: partMaterial.Actual
				})
			});
		}
	});
});